export default __webpack_public_path__ + "static/media/bell-disabled.efb3eca3.svg";